import { render } from "./ChallengeCharacteristics.vue?vue&type=template&id=a1c8b596"
import script from "./ChallengeCharacteristics.vue?vue&type=script&lang=js"
export * from "./ChallengeCharacteristics.vue?vue&type=script&lang=js"
script.render = render

export default script